import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';

ReactDOM.render(
  // <React.StrictMode>
  <div>
    <div width="100%" heigh="15%" className='appHeaderDiv'>
      <p className='appHeaderText'>Netcase</p>
    </div>
    <App />
  </div>,
  // </React.StrictMode>,
  // <EventSimulator />,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
